(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  var WISH_KEY = '89_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function syncWishButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wish-id]').forEach(function (btn) {
      btn.classList.toggle('is-on', list.indexOf(btn.dataset.wishId) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish-id]');
    if (!btn) return;
    var id = btn.dataset.wishId;
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) { list.push(id); btn.classList.add('is-on'); }
    else { list.splice(idx, 1); btn.classList.remove('is-on'); }
    saveWishlist(list);
  });

  document.addEventListener('DOMContentLoaded', syncWishButtons);
})();
  } catch(e) { console.error(e); }
})();

})();
